import { Check, User, Building2, CreditCard, Rocket } from "lucide-react";
import { cn } from "@/lib/utils";

interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
}

const steps = [
  { icon: User, label: "Dados Pessoais", shortLabel: "Pessoal" },
  { icon: Building2, label: "Empresa", shortLabel: "Empresa" },
  { icon: CreditCard, label: "Plano", shortLabel: "Plano" },
  { icon: Rocket, label: "Finalizar", shortLabel: "Finalizar" },
];

export function OnboardingProgress({ currentStep, totalSteps }: OnboardingProgressProps) {
  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const Icon = step.icon;

          return (
            <div key={index} className="flex flex-col items-center flex-1">
              <div className="relative flex items-center justify-center w-full">
                {/* Linha conectora à esquerda */}
                {index > 0 && (
                  <div
                    className={cn(
                      "absolute left-0 right-1/2 h-1 top-6 -translate-y-1/2 transition-colors duration-300",
                      isCompleted || isCurrent ? "bg-primary" : "bg-muted"
                    )}
                  />
                )}
                
                {/* Linha conectora à direita */}
                {index < steps.length - 1 && (
                  <div
                    className={cn(
                      "absolute left-1/2 right-0 h-1 top-6 -translate-y-1/2 transition-colors duration-300",
                      isCompleted ? "bg-primary" : "bg-muted"
                    )}
                  />
                )}

                {/* Círculo do step */}
                <div
                  className={cn(
                    "relative z-10 flex items-center justify-center w-12 h-12 rounded-full border-3 transition-all duration-300 shadow-md",
                    isCompleted && "bg-primary border-primary text-primary-foreground shadow-primary/30",
                    isCurrent && "bg-primary/10 border-primary text-primary ring-4 ring-primary/20",
                    !isCompleted && !isCurrent && "bg-muted border-muted-foreground/30 text-muted-foreground"
                  )}
                >
                  {isCompleted ? (
                    <Check className="w-6 h-6" strokeWidth={3} />
                  ) : (
                    <Icon className="w-5 h-5" />
                  )}
                </div>
              </div>

              {/* Label do step */}
              <span
                className={cn(
                  "mt-3 text-xs sm:text-sm font-medium text-center transition-colors hidden sm:block",
                  isCurrent && "text-primary font-semibold",
                  isCompleted && "text-primary",
                  !isCompleted && !isCurrent && "text-muted-foreground"
                )}
              >
                {step.label}
              </span>
              
              {/* Label curto para mobile */}
              <span
                className={cn(
                  "mt-2 text-[10px] font-medium text-center transition-colors sm:hidden",
                  isCurrent && "text-primary font-semibold",
                  isCompleted && "text-primary",
                  !isCompleted && !isCurrent && "text-muted-foreground"
                )}
              >
                {step.shortLabel}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
